import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { EventSocket, type GameEvent } from '../lib/events.js';
import { useTRPC } from '../lib/trpc.js';

export const eventSocket = new EventSocket();

/** Verbindet den Event-Socket mit dem Query-Cache: Server-Event -> betroffene Queries neu laden. */
export function useGameEvents(onEvent?: (ev: GameEvent) => void) {
  const qc = useQueryClient();
  const trpc = useTRPC();
  useEffect(() => {
    eventSocket.start();
    const off = eventSocket.on((ev) => {
      if (ev.hiveId !== undefined) {
        void qc.invalidateQueries({ queryKey: trpc.hive.get.queryKey({ hiveId: ev.hiveId }) });
      }
      if (ev.type === 'chat.message') void qc.invalidateQueries({ queryKey: trpc.chat.pathKey() });
      if (ev.type === 'alliance.updated') {
        void qc.invalidateQueries({ queryKey: trpc.alliance.pathKey() });
        void qc.invalidateQueries({ queryKey: trpc.chat.pathKey() });
        void qc.invalidateQueries({ queryKey: trpc.map.pathKey() });
      }
      if (ev.type === 'report.new') void qc.invalidateQueries({ queryKey: trpc.report.pathKey() });
      if (ev.type.startsWith('movement.')) {
        void qc.invalidateQueries({ queryKey: trpc.movement.pathKey() });
        void qc.invalidateQueries({ queryKey: trpc.map.pathKey() });
      }
      if (ev.type === 'player.joined')
        void qc.invalidateQueries({ queryKey: trpc.auth.me.queryKey() });
      if (ev.type === 'plan.updated')
        void qc.invalidateQueries({ queryKey: trpc.alliance.pathKey() });
      if (ev.type === 'support.updated')
        void qc.invalidateQueries({ queryKey: trpc.hive.pathKey() });
      if (ev.type === 'quest.completed')
        void qc.invalidateQueries({ queryKey: trpc.quest.pathKey() });
      if (ev.type === 'movement.incoming')
        void qc.invalidateQueries({ queryKey: trpc.movement.incoming.pathKey() });
      if (ev.type === 'protection.expired' || ev.type === 'shield.expired') {
        void qc.invalidateQueries({ queryKey: trpc.auth.me.queryKey() });
        void qc.invalidateQueries({ queryKey: trpc.hive.pathKey() });
      }
      onEvent?.(ev);
    });
    return () => {
      off();
      eventSocket.stop();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qc]);
}
